import Mitt from "mitt";

export const emitter = Mitt<any>();

export enum EventType {
    OnDateSelected,
    OnTimeSelected
};